// extracted by mini-css-extract-plugin
export var actionButton = "_yk-2";
export var card = "_yk-0";
export var disambiguationList = "_yk-3";
export var errorCard = "_yk-4";
export var row = "_yk-1";